import { NgModule } from '@angular/core';

import BetBuilderBetInputBuilder from './services/bet-builder-bet-input-builder';
import BetslipBarInputBuilderService from './services/betslip-bar-input-builder.service';
import { BetslipGeneratorInputBuilder } from './services/betslip-generator-input-builder.service';
import { BetslipGeneratorService } from './services/betslip-generator.service';
import ComboBetInputBuilder from './services/combo-bet-input-builder';
import EditBetInputBuilder from './services/edit-bet-input-builder';
import MultiReturnsMessageInputBuilderService from './services/multi-returns-message-input-builder.service';
import SingleBetInputBuilder from './services/single-bet-input-builder';
import SystemBetInputBuilder from './services/system-bet/system-bet-input-builder';
import TeaserBetInputBuilder from './services/teaser-bet-input-builder';
import UpsellInputBuilder from './services/upsell-bet-input-builder';

@NgModule({
    providers: [
        BetslipGeneratorService,
        SingleBetInputBuilder,
        ComboBetInputBuilder,
        SystemBetInputBuilder,
        TeaserBetInputBuilder,
        EditBetInputBuilder,
        BetBuilderBetInputBuilder,
        BetslipGeneratorInputBuilder,
        MultiReturnsMessageInputBuilderService,
        UpsellInputBuilder,
        BetslipBarInputBuilderService,
    ],
})
export default class BetslipDigitalBetGenerationModule {}
